/**
 * @desc 老师
 */
const teacherList = (r) =>
  require.ensure(
    [],
    () => r(require('../views/teacher/TeacherList.vue')),
    'teacherList'
  )
const uploadAttendance = (r) =>
  require.ensure(
    [],
    () => r(require('../views/teacher/UploadAttendance.vue')),
    'uploadAttendance'
  )

export default [
  //老师管理
  {
    name: 'teacherList',
    path: '/teacherList',
    component: teacherList,
    meta: { title: '老师管理' },
  },
  //考勤上传
  {
    name: 'uploadAttendance',
    path: '/uploadAttendance',
    component: uploadAttendance,
    meta: { title: '考勤上传' },
  },
]
